import { useRouter } from 'next/navigation';

const useDirectDetail = () => {
  const router = useRouter();

  const handleDirectDetail = (
    slug: string,
    id: string,
    type: string,
    isStructure: boolean,
    isObjectOneTime: boolean,
    isProvince?: boolean,
  ) => {
    const queryParams = new URLSearchParams({
      type,
      structure: isStructure.toString(),
      ...(isProvince ? { province: isProvince.toString() } : {}),
      ...(isObjectOneTime
        ? { isObjectOneTime: isObjectOneTime?.toString() }
        : {}),
    });

    const targetUrl = `/thong-tin-chi-tiet/${slug}/${id}?${queryParams.toString()}`;
    router.push(targetUrl);
  };

  return { handleDirectDetail };
};

export default useDirectDetail;
